export interface ArticleSection {
  heading?: string;
  paragraphs: string[];
}

export interface BeautyArticle {
  id: string;
  category: string;
  title: string;
  excerpt: string;
  readTime: string;
  date: string;
  image: string;
  featured?: boolean;
  tags: string[];
  content: ArticleSection[];
}

export const beautyCategories: string[] = ["전체", "피부 관리", "수분", "트러블", "탄력", "홈케어"];

export const beautyArticles: BeautyArticle[] = [
  {
    id: "a1",
    category: "피부 관리",
    title: "모공이 넓어지는 진짜 이유와 관리법",
    excerpt: "모공은 한 번 넓어지면 되돌리기 어렵다고 하지만, 꾸준한 관리로 충분히 개선할 수 있습니다. 모공이 넓어지는 원인부터 집에서 실천할 수 있는 관리법까지 차근차근 알려드립니다.",
    readTime: "5분",
    date: "2026.09.12",
    image: "https://readdy.ai/api/search-image?query=Skincare%20article%20cover%20concept%20of%20clear%20smooth%20skin%20texture%20with%20magnifying%20glass%20examining%20pores%20soft%20dusty%20pink%20and%20white%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20clean%20background%20refined%20aesthetic&width=800&height=500&seq=bianca-article-pore&orientation=landscape",
    featured: true,
    tags: ["모공 관리", "피지 조절", "홈케어"],
    content: [
      {
        heading: "모공이 넓어지는 진짜 이유",
        paragraphs: [
          "모공은 피지가 배출되는 통로로, 피부 건강을 위해 반드시 필요한 구조입니다. 하지만 과도한 피지 분비, 노화로 인한 탄력 저하, 자외선으로 인한 콜라겐 손상 등이 겹치면 모공이 눈에 띄게 넓어지기 시작합니다.",
          "특히 T존 부위는 피지선이 밀집해 있어 모공이 넓어지기 쉽습니다. 여기에 올바르지 않은 압출이나 과도한 각질 제거가 더해지면 모공 주변이 자극받아 더욱 도드라져 보일 수 있어요. 원인을 정확히 아는 것이 관리의 첫걸음입니다.",
        ],
      },
      {
        heading: "일상에서 실천하는 모공 관리법",
        paragraphs: [
          "모공 관리는 하루아침에 끝나지 않습니다. 가장 중요한 것은 과도한 피지를 꾸준히 조절하고, 모공 주변의 탄력을 유지하는 습관이에요. 저자극 클렌징으로 피지를 부드럽게 닦아내고, 수분과 유분의 균형을 맞춰주는 것이 기본입니다.",
          "또한 주 1~2회 정도의 순한 각질 관리와 함께, 피지를 효과적으로 정돈해주는 성분의 제품을 선택하는 것이 좋습니다. 다만 과도한 각질 제거나 강한 압출은 오히려 피부 장벽을 손상시켜 모공을 더욱 넓게 보이게 만들 수 있으니 주의해야 합니다.",
        ],
      },
      {
        heading: "관리 후 유지가 더 중요합니다",
        paragraphs: [
          "샵에서 받는 전문적인 모공 관리는 즉각적인 개선 효과를 주지만, 그 효과를 오래 유지하려면 홈케어가 뒷받침되어야 합니다. 매일의 클렌징과 보습, 그리고 자외선 차단제 사용을 꾸준히 실천해주세요.",
          "비앙카에서는 피부 타입과 모공 상태를 정확히 진단한 뒤, 고객 한 분 한 분에게 맞는 관리 프로그램과 홈케어 루틴을 제안해드리고 있습니다. 모공 고민이 오래됐다면 전문가의 진단을 받아보시는 것을 추천합니다.",
        ],
      },
    ],
  },
  {
    id: "a2",
    category: "수분",
    title: "수분 부족 피부, 제대로 채우는 법",
    excerpt: "아무리 수분크림을 발라도 당기는 피부. 수분은 피부 표면이 아닌 속부터 채워야 합니다. 수분 부족 신호와 올바른 수분 관리 루틴을 소개합니다.",
    readTime: "4분",
    date: "2026.09.05",
    image: "https://readdy.ai/api/search-image?query=Hydration%20skincare%20article%20concept%20with%20water%20droplets%20serum%20bottle%20and%20dewy%20skin%20in%20soft%20pink%20and%20light%20blue%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20fresh%20aesthetic&width=800&height=500&seq=bianca-article-hydration&orientation=landscape",
    tags: ["수분 관리", "건성 피부", "보습"],
    content: [
      {
        heading: "피부가 보내는 수분 부족 신호",
        paragraphs: [
          "세안 후 피부가 빠르게 당기거나, 화장이 잘 뜨고 들뜨는 느낌이 든다면 피부가 수분 부족 상태라는 신호입니다. 피부가 건조하면 표면의 각질이 고르게 탈락하지 못해 피부가 칙칙해 보이고, 잔주름이 도드라져 보이기도 합니다.",
          "단순히 겉이 건조한 것이 아니라, 피부 속 수분이 부족하면 피부 장벽이 약해져 외부 자극에 더욱 민감해질 수 있습니다. 그래서 수분은 겉으로 보이는 촉촉함이 아닌, 속부터 채워주는 것이 중요합니다.",
        ],
      },
      {
        heading: "수분을 제대로 채우는 루틴",
        paragraphs: [
          "수분 관리는 세안 직후가 가장 중요합니다. 세안 후 물기가 완전히 마르기 전에 토너로 정돈하고, 수분 세럼을 흡수시킨 뒤 보습제로 수분을 가두는 순서가 기본입니다. 수분을 채우고, 그 수분이 증발하지 않도록 막아주는 두 단계를 함께 해주세요.",
          "건성 피부라면 오일 성분이 함유된 보습제로, 지성 피부라면 가벼운 제형의 수분 크림으로 마무리하는 것이 좋습니다. 피부 타입에 맞는 제형 선택이 수분 유지의 핵심입니다.",
        ],
      },
      {
        heading: "생활 속 수분 유지 습관",
        paragraphs: [
          "수분은 피부 관리만으로 유지되지 않습니다. 하루 물 섭취량을 충분히 지키고, 실내 습도를 적정하게 유지하는 것도 피부 수분에 큰 영향을 줍니다. 과도한 난방이나 에어컨은 피부를 더 건조하게 만들 수 있어요.",
          "비앙카의 수분 관리 프로그램은 피부 속부터 깊이 채워주는 전문 관리로, 건조한 피부로 고민하는 분들께 큰 도움을 드리고 있습니다. 자세한 상담은 예약을 통해 언제든지 받아보실 수 있습니다.",
        ],
      },
    ],
  },
  {
    id: "a3",
    category: "트러블",
    title: "트러블 피부, 생활 습관부터 점검해보세요",
    excerpt: "피부 트러블은 피부 자체보다 생활 습관에서 비롯되는 경우가 많습니다. 수면, 식습관, 스트레스까지 트러블을 부르는 습관과 개선 방법을 알아봅니다.",
    readTime: "6분",
    date: "2026.08.28",
    image: "https://readdy.ai/api/search-image?query=Acne%20trouble%20skincare%20article%20concept%20with%20gentle%20green%20botanical%20and%20clean%20skin%20in%20soft%20mint%20and%20cream%20tones%20minimalist%20beauty%20editorial%20photography%20calm%20healing%20aesthetic%20bright%20background&width=800&height=500&seq=bianca-article-trouble&orientation=landscape",
    tags: ["트러블", "생활 습관", "여드름"],
    content: [
      {
        heading: "트러블을 부르는 생활 습관",
        paragraphs: [
          "피부 트러블은 단순히 피부 표면의 문제가 아니라, 수면 부족과 불규칙한 식습관, 스트레스 등 생활 습관이 깊이 관여하는 경우가 많습니다. 늦은 시간까지 이어지는 야식이나, 손으로 얼굴을 자주 만지는 습관도 트러블을 악화시키는 원인이 됩니다.",
          "특히 스트레스가 쌓이면 호르몬 균형이 흔들리면서 피지 분비가 늘고, 이는 곧 트러블로 이어지기 쉽습니다. 그래서 트러블 관리는 피부에 바르는 것보다 생활 패턴을 점검하는 것이 우선입니다.",
        ],
      },
      {
        heading: "수면과 식습관이 피부에 미치는 영향",
        paragraphs: [
          "피부는 잠을 자는 동안 재생됩니다. 수면이 부족하면 피부 재생이 제대로 이루어지지 않아 트러블 회복이 더뎌지고, 피부가 쉽게 붉어지고 예민해질 수 있습니다. 하루 7시간 이상의 규칙적인 수면을 지켜주세요.",
          "식습관 역시 중요합니다. 과도한 당분과 기름진 음식은 피지 분비를 자극할 수 있어, 신선한 채소와 과일, 충분한 수분 섭취로 균형 잡힌 식단을 유지하는 것이 트러블 관리에 도움이 됩니다.",
        ],
      },
      {
        heading: "트러블 개선을 위한 실천법",
        paragraphs: [
          "트러블이 났을 때 가장 중요한 것은 손으로 짜지 않는 것입니다. 잘못된 압출은 피부에 상처와 흉터를 남길 수 있어요. 대신 저자극 클렌징과 가벼운 보습으로 피부를 진정시키고, 필요한 경우 전문가의 도움을 받는 것이 안전합니다.",
          "비앙카에서는 트러블의 원인을 정확히 파악한 뒤, 피부 상태에 맞는 진정 관리 프로그램을 제공해드리고 있습니다. 반복되는 트러블로 고민이라면 한 번 상담을 받아보시길 추천드립니다.",
        ],
      },
    ],
  },
  {
    id: "a4",
    category: "탄력",
    title: "피부 탄력을 높이는 생활 습관 5가지",
    excerpt: "탄력은 시술만으로 완성되지 않습니다. 매일의 작은 습관이 모여 동안 피부를 만듭니다. 일상에서 실천할 수 있는 탄력 관리 습관을 정리했습니다.",
    readTime: "5분",
    date: "2026.08.20",
    image: "https://readdy.ai/api/search-image?query=Firming%20skincare%20article%20concept%20with%20facial%20massage%20tool%20and%20youthful%20glowing%20skin%20in%20rose%20pink%20and%20warm%20neutral%20tones%20minimalist%20beauty%20editorial%20photography%20elegant%20bright%20aesthetic&width=800&height=500&seq=bianca-article-lifting&orientation=landscape",
    tags: ["탄력", "동안 피부", "안티에이징"],
    content: [
      {
        heading: "피부 탄력이 떨어지는 이유",
        paragraphs: [
          "피부 탄력은 나이가 들수록 자연스럽게 감소합니다. 피부 속 콜라겐과 엘라스틴이 줄어들고, 자외선과 스트레스, 불규칙한 생활이 더해지면 탄력 저하가 더욱 빨라집니다. 하지만 좋은 소식은, 꾸준한 관리로 충분히 늦출 수 있다는 점입니다.",
          "탄력 관리의 핵심은 이미 떨어진 탄력을 되돌리는 것보다, 더 떨어지는 속도를 늦추고 현재의 탄력을 유지하는 데 있습니다. 그래서 일상 속 작은 습관이 무엇보다 중요합니다.",
        ],
      },
      {
        heading: "일상에서 실천하는 탄력 습관 5가지",
        paragraphs: [
          "첫째, 자외선 차단제를 매일 바르세요. 자외선은 탄력 저하의 가장 큰 외부 요인입니다. 둘째, 충분한 수면을 취하세요. 피부 재생은 수면 중에 가장 활발하게 일어납니다.",
          "셋째, 수분을 꾸준히 채우세요. 촉촉한 피부는 탄력 있어 보이고 잔주름도 덜 도드라집니다. 넷째, 균형 잡힌 식단으로 단백질과 비타민을 섭취하세요. 다섯째, 표정 근육을 자극하는 가벼운 마사지로 피부 순환을 도와주세요.",
        ],
      },
      {
        heading: "꾸준함이 만드는 동안 피부",
        paragraphs: [
          "탄력 관리는 하루 이틀의 노력으로 결과가 나오지 않습니다. 하지만 매일의 작은 습관이 쌓이면 몇 달 후 확실히 다른 피부를 만날 수 있습니다. 조급해하지 말고 꾸준히 실천하는 것이 가장 중요해요.",
          "비앙카의 탄력 관리 프로그램은 피부의 처진 부위를 집중적으로 관리하여 리프팅 효과를 높여드리고 있습니다. 탄력 고민이 시작됐다면 전문 관리를 병행해보시는 것을 추천합니다.",
        ],
      },
    ],
  },
  {
    id: "a5",
    category: "홈케어",
    title: "홈케어의 중요성과 기본 루틴",
    excerpt: "샵에서 받는 관리의 효과를 오래 유지하려면 홈케어가 필수입니다. 아침·저녁으로 나누는 기본 스킨케어 루틴을 단계별로 알려드립니다.",
    readTime: "7분",
    date: "2026.08.12",
    image: "https://readdy.ai/api/search-image?query=Home%20skincare%20routine%20article%20concept%20with%20neatly%20arranged%20skincare%20products%20cotton%20pads%20and%20mirror%20in%20soft%20white%20and%20blush%20pink%20tones%20minimalist%20beauty%20editorial%20photography%20clean%20bright%20aesthetic&width=800&height=500&seq=bianca-article-home&orientation=landscape",
    tags: ["홈케어", "스킨케어 루틴", "기초 관리"],
    content: [
      {
        heading: "홈케어가 중요한 이유",
        paragraphs: [
          "샵에서 받는 전문 관리는 단발적인 개선이 아니라, 피부가 스스로 회복할 수 있는 기반을 만들어주는 과정입니다. 그 기반을 유지하고 관리 효과를 오래 지속시키는 것은 결국 매일의 홈케어가 결정합니다.",
          "아무리 좋은 관리도 홈케어가 뒷받침되지 않으면 효과가 오래 가지 않습니다. 반대로 꾸준한 홈케어는 관리 간격을 늘려주고, 더 건강한 피부 상태를 유지하게 해줍니다.",
        ],
      },
      {
        heading: "아침 루틴, 가볍고 깨끗하게",
        paragraphs: [
          "아침에는 밤사이 쌓인 노폐물을 부드럽게 닦아내는 저자극 클렌징으로 시작하세요. 그다음 토너로 피부 결을 정돈하고, 수분 세럼으로 속부터 채운 뒤, 자외선 차단제로 마무리하는 것이 기본입니다.",
          "아침 루틴은 과하지 않게, 가볍고 깨끗하게가 핵심입니다. 제품을 너무 많이 바르면 오히려 피부에 부담이 될 수 있으니 필요한 것만 간결하게 사용해주세요.",
        ],
      },
      {
        heading: "저녁 루틴, 꼼꼼하게 채워주기",
        paragraphs: [
          "저녁에는 하루 동안 쌓인 메이크업과 노폐물을 꼼꼼하게 제거하는 이중 세안이 중요합니다. 이후 토너와 세럼, 보습제 순서로 피부를 진정시키고 충분히 채워주세요.",
          "밤은 피부가 재생되는 시간이기 때문에, 낮보다 영양과 보습에 조금 더 신경 써도 좋습니다. 단, 피부 타입에 맞지 않는 과한 영양은 트러블의 원인이 될 수 있으니 자신의 피부에 맞게 조절해주세요.",
        ],
      },
      {
        heading: "계절에 맞는 홈케어",
        paragraphs: [
          "피부는 계절에 따라 상태가 달라집니다. 여름에는 가볍고 산뜻한 제형으로, 겨울에는 보습력이 높은 제형으로 바꿔주는 것이 좋아요. 계절이 바뀔 때마다 자신의 피부 상태를 점검하고 제품을 조정해보세요.",
          "비앙카에서는 관리 후 고객의 피부 상태에 맞는 홈케어 루틴을 자세히 안내해드리고 있습니다. 홈케어 방법이 궁금하시다면 언제든지 상담을 신청해주세요.",
        ],
      },
    ],
  },
  {
    id: "a6",
    category: "피부 관리",
    title: "겨울철 건조한 피부를 지키는 관리 팁",
    excerpt: "건조한 겨울, 피부는 더욱 예민해지기 쉽습니다. 실내 난방과 찬 바람 속에서도 촉촉함을 유지하는 겨울철 피부 관리 포인트를 소개합니다.",
    readTime: "4분",
    date: "2026.08.03",
    image: "https://readdy.ai/api/search-image?query=Winter%20skincare%20article%20concept%20with%20moisturizing%20cream%20and%20soft%20warm%20texture%20in%20dusty%20pink%20and%20cream%20tones%20minimalist%20beauty%20editorial%20photography%20cozy%20bright%20aesthetic&width=800&height=500&seq=bianca-article-winter&orientation=landscape",
    tags: ["겨울 피부", "건조", "보습"],
    content: [
      {
        heading: "겨울에 피부가 더 건조해지는 이유",
        paragraphs: [
          "겨울에는 차가운 바깥 공기와 건조한 실내 난방이 반복되면서 피부 수분이 빠르게 증발합니다. 여기에 피부 장벽이 약해지면 피부가 쉽게 당기고, 붉어지거나 가려움을 느끼기 쉬워집니다.",
          "특히 난방이 강한 실내는 습도가 크게 낮아져, 외출하지 않아도 피부가 건조해질 수 있습니다. 그래서 겨울에는 보습에 각별한 신경을 써야 합니다.",
        ],
      },
      {
        heading: "겨울철 피부 관리 포인트",
        paragraphs: [
          "겨울에는 세안부터 바꿔보세요. 너무 뜨거운 물보다 미지근한 물로 세안하고, 세안 직후 수분이 마르기 전에 보습을 시작하는 것이 좋습니다. 보습제는 평소보다 조금 더 보습력이 높은 제품으로 선택해주세요.",
          "또한 자외선 차단은 겨울에도 필수입니다. 겨울 자외선도 피부 탄력을 떨어뜨리고 건조를 악화시킬 수 있어요. 흐린 날에도 꾸준히 발라주는 것이 좋습니다.",
        ],
      },
      {
        heading: "실내 환경 관리도 잊지 마세요",
        paragraphs: [
          "실내 습도를 40~60% 정도로 유지하는 것이 피부 건강에 좋습니다. 가습기를 활용하거나, 젖은 수건을 걸어두는 것만으로도 실내 건조를 줄일 수 있어요. 하루 충분한 물 섭취도 피부 수분 유지에 도움이 됩니다.",
          "비앙카의 보습 관리 프로그램은 건조한 겨울철 피부에 깊은 수분을 공급해드립니다. 겨울 피부 건조로 고민이시라면 예약을 통해 상담받아보시길 추천드립니다.",
        ],
      },
    ],
  },
  {
    id: "a7",
    category: "피부 관리",
    title: "여름철 피지 관리, 산뜻하게 시작하기",
    excerpt: "덥고 습한 여름, 피지 분비가 늘면서 피부가 번들거리고 화장이 무너지기 쉽습니다. 여름철 피지 관리의 핵심 포인트와 산뜻한 피부를 유지하는 방법을 알려드립니다.",
    readTime: "5분",
    date: "2026.07.27",
    image: "https://readdy.ai/api/search-image?query=Summer%20skincare%20oil%20control%20article%20concept%20with%20fresh%20citrus%20and%20mattifying%20products%20in%20soft%20peach%20and%20cream%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20clean%20background&width=800&height=500&seq=bianca-article-summer-oil&orientation=landscape",
    tags: ["피지 관리", "여름 피부", "유분 조절"],
    content: [
      {
        heading: "여름에 피지가 늘어나는 이유",
        paragraphs: [
          "기온이 1도 올라갈수록 피지 분비량은 늘어난다고 합니다. 여름에는 높은 기온과 습도 때문에 피지선이 활발해지면서 피부가 쉽게 번들거리고, 과도한 피지가 모공을 막아 트러블로 이어지기 쉽습니다.",
          "하지만 피지를 무조건 없애려고 세게 닦아내면 오히려 피부 장벽이 손상되어 더 많은 피지를 분비하는 악순환에 빠질 수 있어요. 여름에는 과도한 제거보다 균형을 잡는 관리가 중요합니다.",
        ],
      },
      {
        heading: "여름철 피지 관리 루틴",
        paragraphs: [
          "여름에는 저자극 클렌징으로 피지를 부드럽게 닦아내고, 가볍고 산뜻한 제형의 수분 제품으로 유수분 균형을 맞춰주세요. 너무 무거운 오일 제품보다는 수분감이 풍부한 제품이 여름 피부에 잘 맞습니다.",
          "주 1~2회의 순한 각질 관리를 더해주면 모공 속 노폐물을 정돈하고 피지를 조절하는 데 도움이 됩니다. 다만 과도한 각질 제거는 피부를 예민하게 만들 수 있으니 횟수를 지켜주세요.",
          "번들거림을 줄이려면 자외선 차단제를 꼼꼼히 바르고, 기름진 음식보다 신선한 채소와 충분한 수분을 섭취하는 것이 좋습니다. 비앙카에서는 여름철 피지 조절 관리 프로그램으로 산뜻한 피부를 도와드리고 있습니다.",
        ],
      },
    ],
  },
  {
    id: "a8",
    category: "수분",
    title: "수분 부족 vs 유분 부족, 헷갈리는 피부 구분법",
    excerpt: "피부가 당기는데도 번들거린다면, 수분 부족과 유분 부족을 혼동하고 있을 수 있습니다. 두 상태의 차이를 정확히 구분하고 맞는 관리를 찾아보세요.",
    readTime: "4분",
    date: "2026.07.20",
    image: "https://readdy.ai/api/search-image?query=Skincare%20article%20concept%20comparing%20water%20and%20oil%20texture%20with%20dropper%20bottle%20and%20emulsion%20in%20soft%20blue%20and%20ivory%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20clean%20background&width=800&height=500&seq=bianca-article-water-oil&orientation=landscape",
    tags: ["수분 부족", "유분 부족", "피부 타입"],
    content: [
      {
        heading: "수분 부족과 유분 부족, 무엇이 다를까",
        paragraphs: [
          "수분 부족 피부는 겉으로 당기고, 세안 후 빠르게 건조해지며 잔주름이 도드라져 보입니다. 반면 유분 부족 피부는 피부 표면의 보호막이 약해져 쉽게 붉어지고 예민해지며, 피부가 거칠게 느껴집니다.",
          "많은 분이 피부가 번들거리면 유분이 많다고 생각하지만, 수분이 부족해 피부가 스스로 유분을 과다 분비하는 경우도 많습니다. 그래서 번들거림이 있다고 해서 무조건 유분을 제거하면 오히려 건조해질 수 있어요.",
        ],
      },
      {
        heading: "내 피부 타입 정확히 구분하기",
        paragraphs: [
          "세안 후 아무것도 바르지 않은 상태에서 피부가 얼마나 빨리 당기는지 확인해보세요. 1~2분 안에 심하게 당기면 수분 부족일 가능성이 높고, 거칠고 각질이 잘 일어나면 유분 부족일 수 있습니다.",
          "정확한 피부 타입 진단은 전문가의 도움을 받는 것이 가장 확실합니다. 비앙카에서는 피부 진단을 통해 수분과 유분의 균형을 정확히 파악하고, 그에 맞는 관리 프로그램을 제안해드리고 있습니다.",
        ],
      },
    ],
  },
  {
    id: "a9",
    category: "탄력",
    title: "목과 턱선 탄력, 나이보다 빨리 무너진다",
    excerpt: "얼굴은 신경 써도 목과 턱선은 놓치기 쉽습니다. 피부가 얇은 목은 탄력이 가장 먼저 떨어지는 부위입니다. 목과 턱선 탄력을 지키는 방법을 알아봅니다.",
    readTime: "5분",
    date: "2026.07.13",
    image: "https://readdy.ai/api/search-image?query=Neck%20and%20jawline%20firming%20skincare%20article%20concept%20with%20elegant%20facial%20massage%20and%20lifting%20effect%20in%20rose%20pink%20and%20cream%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20background&width=800&height=500&seq=bianca-article-neck&orientation=landscape",
    tags: ["목 탄력", "턱선", "리프팅"],
    content: [
      {
        heading: "목과 턱선이 먼저 나이를 보여주는 이유",
        paragraphs: [
          "목의 피부는 얼굴보다 얇고 피지선이 적어 수분과 탄력을 유지하기 어렵습니다. 여기에 스마트폰을 보느라 고개를 숙이는 습관이 더해지면 목 주름이 깊어지고 턱선이 무너지기 쉽습니다.",
          "목과 턱선은 얼굴보다 관리가 소홀해지기 쉬운 부위이지만, 오히려 그렇기 때문에 나이가 가장 먼저 드러나는 곳이기도 합니다. 평소의 자세와 관리 습관이 중요합니다.",
        ],
      },
      {
        heading: "목·턱선 탄력 관리법",
        paragraphs: [
          "목에도 얼굴과 같은 스킨케어를 꼼꼼히 해주세요. 보습제를 바를 때 목과 턱선까지 충분히 발라주고, 아래에서 위로 가볍게 마사지하는 것이 탄력 유지에 도움이 됩니다.",
          "고개를 숙이는 자세를 줄이고, 화면을 눈높이에 맞추는 것만으로도 목 주름 예방에 큰 도움이 됩니다. 비앙카의 탄력 관리 프로그램은 목과 턱선 부위를 집중 관리하여 또렷한 라인을 만들어드립니다.",
        ],
      },
    ],
  },
  {
    id: "a10",
    category: "홈케어",
    title: "민감성 피부를 위한 저자극 홈케어 가이드",
    excerpt: "조금만 자극해도 붉어지고 따가운 민감성 피부. 복잡한 루틴보다는 최소한의 저자극 관리가 더 효과적입니다. 민감성 피부를 위한 홈케어 방법을 정리했습니다.",
    readTime: "6분",
    date: "2026.07.06",
    image: "https://readdy.ai/api/search-image?query=Sensitive%20skin%20gentle%20skincare%20article%20concept%20with%20soothing%20botanical%20cream%20and%20soft%20cotton%20in%20pale%20green%20and%20white%20tones%20minimalist%20beauty%20editorial%20photography%20calm%20bright%20background&width=800&height=500&seq=bianca-article-sensitive&orientation=landscape",
    tags: ["민감성 피부", "저자극", "진정 케어"],
    content: [
      {
        heading: "민감성 피부, 자극을 줄이는 것이 우선",
        paragraphs: [
          "민감성 피부는 피부 장벽이 약해져 외부 자극에 쉽게 반응합니다. 이럴 때일수록 기능성 제품을 많이 바르기보다, 자극을 최소화하고 피부를 진정시키는 것이 가장 중요합니다.",
          "향료나 알코올이 강한 제품은 피하시고, 가능하면 성분이 단순하고 순한 제품을 선택하세요. 새로운 제품을 사용할 때는 팔 안쪽에 먼저 테스트해보는 습관도 도움이 됩니다.",
        ],
      },
      {
        heading: "저자극 홈케어 가이드",
        paragraphs: [
          "세안은 미지근한 물로 부드럽게, 거품을 충분히 내어 손의 마찰을 줄여주세요. 세안 후에는 피부가 마르기 전에 순한 보습제로 수분을 잡아주는 것이 진정에 도움이 됩니다.",
          "피부가 예민한 시기에는 각질 제거나 강한 마사지를 잠시 쉬어가며 피부에 휴식을 주는 것도 좋습니다. 비앙카에서는 민감성 피부를 위한 저자극 진정 관리 프로그램을 운영하고 있습니다.",
        ],
      },
    ],
  },
  {
    id: "a11",
    category: "트러블",
    title: "성인 여드름, 청소년기와 다른 관리법",
    excerpt: "20대 이후에 나타나는 성인 여드름은 청소년기 여드름과 원인도 관리법도 다릅니다. 성인 여드름의 특징과 올바른 관리 방법을 알려드립니다.",
    readTime: "5분",
    date: "2026.06.28",
    image: "https://readdy.ai/api/search-image?query=Adult%20acne%20skincare%20article%20concept%20with%20clean%20minimal%20skincare%20tools%20and%20calm%20skin%20in%20soft%20sage%20and%20cream%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20healing%20background&width=800&height=500&seq=bianca-article-adult-acne&orientation=landscape",
    tags: ["성인 여드름", "트러블", "호르몬"],
    content: [
      {
        heading: "성인 여드름, 청소년기와 다른 이유",
        paragraphs: [
          "성인 여드름은 주로 턱과 입 주변, 볼에 나타나는 경우가 많고, 청소년기 여드름보다 피부가 건조하고 예민한 상태에서 발생하는 경우가 많습니다. 호르몬 변화, 스트레스, 수면 부족 등이 주된 원인입니다.",
          "청소년기에는 피지 분비가 많아 기름진 피부가 특징이지만, 성인 여드름은 건조함과 민감함이 동반되는 경우가 많아 강한 건조 제품이나 자극적인 관리가 오히려 악화시킬 수 있습니다.",
        ],
      },
      {
        heading: "성인 여드름 관리법",
        paragraphs: [
          "성인 여드름은 과도한 피지 제거보다 수분과 유분의 균형을 맞추는 것이 중요합니다. 저자극 클렌징과 가벼운 보습으로 피부 장벽을 지키면서, 트러블 부위는 손으로 짜지 말고 진정시키는 것이 좋습니다.",
          "생활 습관도 중요합니다. 충분한 수면과 규칙적인 식사, 스트레스 관리는 성인 여드름 개선에 큰 도움이 됩니다. 비앙카에서는 성인 여드름의 원인을 파악해 맞춤 진정 관리를 제공해드리고 있습니다.",
        ],
      },
    ],
  },
  {
    id: "a12",
    category: "피부 관리",
    title: "자외선 차단제, 제대로 고르고 바르는 법",
    excerpt: "자외선 차단제는 모든 피부 관리의 기본입니다. 하지만 제대로 고르고, 충분한 양을 올바르게 발라야 효과를 볼 수 있습니다. 자외선 차단제 사용법을 정리했습니다.",
    readTime: "4분",
    date: "2026.06.20",
    image: "https://readdy.ai/api/search-image?query=Sunscreen%20skincare%20article%20concept%20with%20sunscreen%20bottle%20and%20soft%20sunlight%20shadow%20in%20warm%20beige%20and%20cream%20tones%20minimalist%20beauty%20editorial%20photography%20bright%20clean%20background&width=800&height=500&seq=bianca-article-sunscreen&orientation=landscape",
    tags: ["자외선 차단", "선크림", "피부 노화"],
    content: [
      {
        heading: "자외선 차단제, 왜 매일 발라야 할까",
        paragraphs: [
          "자외선은 피부 노화의 가장 큰 외부 요인입니다. 자외선에 오래 노출되면 피부 탄력이 떨어지고 기미·잡티가 생기기 쉬우며, 건조함과 트러블도 악화될 수 있습니다. 흐린 날에도 자외선은 존재하기 때문에 매일 발라야 합니다.",
          "자외선 차단제는 단순히 피부를 태우지 않게 하는 것이 아니라, 피부 탄력과 톤을 지키는 가장 기본적인 안티에이징 관리입니다. 모든 스킨케어의 마지막 단계로 꼭 챙겨주세요.",
        ],
      },
      {
        heading: "제대로 고르고 바르는 법",
        paragraphs: [
          "일상에서는 SPF30 이상, 야외 활동이 많다면 SPF50 제품을 선택하는 것이 좋습니다. 자신의 피부 타입에 맞는 제형(로션, 크림, 스틱 등)을 고르면 꾸준히 바르기 쉽습니다.",
          "자외선 차단제는 충분한 양을 골고루 발라야 효과가 있습니다. 얼굴 전체에 동전 크기만큼, 목과 귀 뒤까지 잊지 말고 발라주세요. 땀이나 물로 지워졌다면 2~3시간마다 덧발라주는 것이 좋습니다.",
        ],
      },
    ],
  },
];